// extracted by mini-css-extract-plugin
export default {"mainContainer":"Goals_mainContainer__dz87m","goalsContainer":"Goals_goalsContainer__TtS1b","skeletonLoadingAnimation":"Goals_skeletonLoadingAnimation__NTTSB"};